export default __webpack_public_path__ + "642b899141272009dd2ed2bc01ec3cf8.svg";